import { render, staticRenderFns } from "./leave-case-import.vue?vue&type=template&id=e195b7da&scoped=true"
import script from "./leave-case-import.vue?vue&type=script&lang=ts"
export * from "./leave-case-import.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e195b7da",
  null
  
)

export default component.exports